(function (global) {
  'use strict';

  var POUCH_VARIANT_ID = '53954234319212';
  var PROVIDER_CHECKOUT_SELECTOR = 'shop-pay-wallet-button, shopify-amazon-pay-button, '
    + 'shopify-apple-pay-button, shopify-google-pay-button, shopify-paypal-button';
  var ACCELERATED_CHECKOUT_SELECTOR = 'shopify-accelerated-checkout-cart, shopify-accelerated-checkout';
  var CHECKOUT_SELECTOR = '#CartDrawer-Checkout, .cart__checkout-button, [name="checkout"], '
    + '.additional-checkout-buttons button, .additional-checkout-buttons [role="button"]';
  var CART_SURFACE_SELECTOR = 'cart-drawer, #main-cart, .cart-page';
  var ACTIVE_CAMPAIGN_SELECTOR = 'kd-hirono-gift[data-campaign-active="true"]';

  function assign(target) {
    for (var sourceIndex = 1; sourceIndex < arguments.length; sourceIndex += 1) {
      var source = arguments[sourceIndex];
      if (source == null) continue;
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
      }
    }
    return target;
  }

  function asId(value) {
    return String(value == null ? '' : value).replace(/^gid:\/\/shopify\/(?:Product|ProductVariant)\//, '').trim();
  }

  function asQuantity(value) {
    var quantity = Number(value);
    return isFinite(quantity) && quantity > 0 ? Math.floor(quantity) : 0;
  }

  function parseIds(value) {
    return String(value || '').split(',').map(asId).filter(Boolean);
  }

  function isMarkedGift(item) {
    return Boolean(item && item.properties && item.properties._kd_hirono_gift === '1');
  }

  function matchesSelector(element, selector) {
    if (!element || typeof element.matches !== 'function') return false;
    try {
      return element.matches(selector);
    } catch (error) {
      return false;
    }
  }

  function checkoutControlFromEvent(event) {
    var path = [];
    if (event && typeof event.composedPath === 'function') {
      try {
        path = event.composedPath() || [];
      } catch (error) {
        path = [];
      }
    }

    for (var index = 0; index < path.length; index += 1) {
      if (matchesSelector(path[index], PROVIDER_CHECKOUT_SELECTOR)) return path[index];
    }
    for (index = 0; index < path.length; index += 1) {
      if (matchesSelector(path[index], ACCELERATED_CHECKOUT_SELECTOR)) return path[index];
    }

    var target = event && event.target;
    if (!target || typeof target.closest !== 'function') return null;
    try {
      return target.closest(
        PROVIDER_CHECKOUT_SELECTOR + ', ' + ACCELERATED_CHECKOUT_SELECTOR + ', ' + CHECKOUT_SELECTOR
      );
    } catch (error) {
      return null;
    }
  }

  function eventPath(event) {
    if (!event || typeof event.composedPath !== 'function') return [];
    try {
      return event.composedPath() || [];
    } catch (error) {
      return [];
    }
  }

  function closestElement(element, selector) {
    if (!element || typeof element.closest !== 'function') return null;
    try {
      return element.closest(selector);
    } catch (error) {
      return null;
    }
  }

  function activeElement(target, rootDocument, event) {
    var path = eventPath(event);
    var scope = null;
    for (var index = 0; index < path.length; index += 1) {
      if (matchesSelector(path[index], CART_SURFACE_SELECTOR)) {
        scope = path[index];
        break;
      }
    }
    if (!scope) scope = closestElement(target, CART_SURFACE_SELECTOR);
    if (scope) {
      return typeof scope.querySelector === 'function'
        ? scope.querySelector(ACTIVE_CAMPAIGN_SELECTOR)
        : null;
    }

    var form = closestElement(target, 'form');
    if (form) {
      return typeof form.querySelector === 'function'
        ? form.querySelector(ACTIVE_CAMPAIGN_SELECTOR)
        : null;
    }

    var documentRoot = rootDocument || (typeof document !== 'undefined' ? document : null);
    return documentRoot && typeof documentRoot.querySelector === 'function'
      ? documentRoot.querySelector(ACTIVE_CAMPAIGN_SELECTOR)
      : null;
  }

  function setAcceleratedCheckoutBlocked(element, blocked, rootDocument) {
    if (!element) return;
    var scope = closestElement(element, CART_SURFACE_SELECTOR)
      || closestElement(element, 'form')
      || rootDocument
      || (typeof document !== 'undefined' ? document : null);
    if (!scope || typeof scope.querySelectorAll !== 'function') return;
    var accelerated = scope.querySelectorAll('.additional-checkout-buttons');
    for (var index = 0; index < accelerated.length; index += 1) {
      accelerated[index].hidden = blocked;
    }
  }

  function replayCheckoutControl(control) {
    if (!control || typeof control.click !== 'function') return false;
    control.click();
    return true;
  }

  function enrichCart(cart, qualifyingProductIds) {
    var source = cart && typeof cart === 'object' ? cart : {};
    var qualifyingIds = (qualifyingProductIds || []).map(asId);
    var items = Array.isArray(source.items) ? source.items : [];
    return assign({}, source, {
      items: items.map(function (item) {
        return assign({}, item, {
          isHironoCollectionItem: qualifyingIds.indexOf(asId(item && item.product_id)) !== -1,
        });
      }),
    });
  }

  function qualifyingQuantity(items) {
    return items.reduce(function (total, item) {
      if (isMarkedGift(item)) return total;
      if (item.isHironoCollectionItem !== true) return total;
      return total + asQuantity(item.quantity);
    }, 0);
  }

  function lineKey(item) {
    return item.key || String(item.id || item.variant_id);
  }

  function inspectCart(cart, config) {
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    var qualifyingUnits = qualifyingQuantity(items);
    var tier = qualifyingUnits >= 4 ? 'tote' : qualifyingUnits >= 2 ? 'pouch' : 'none';
    var declined = Boolean(cart && cart.attributes && cart.attributes._kd_hirono_gift_declined === '1');
    var desiredGift = null;

    if (tier !== 'none' && !declined) {
      desiredGift = {
        variantId: asId(config && (tier === 'tote' ? config.toteVariantId : config.pouchVariantId)),
        available: config && (tier === 'tote' ? config.toteAvailable === true : config.pouchAvailable === true),
      };
    }

    var marked = items.filter(isMarkedGift);
    var keep = null;
    if (desiredGift && desiredGift.available) {
      for (var markedIndex = 0; markedIndex < marked.length; markedIndex += 1) {
        if (asId(marked[markedIndex] && marked[markedIndex].variant_id) === desiredGift.variantId) {
          keep = marked[markedIndex];
          break;
        }
      }
    }

    var updates = {};
    marked.forEach(function (item) {
      if (item !== keep) updates[lineKey(item)] = 0;
    });
    if (keep && asQuantity(keep.quantity) !== 1) updates[lineKey(keep)] = 1;

    var markedGiftCount = marked.reduce(function (total, item) {
      return total + asQuantity(item.quantity);
    }, 0);
    var unavailable = Boolean(desiredGift && !desiredGift.available);
    var giftToAdd = desiredGift && desiredGift.available && !keep
      ? desiredGift.variantId
      : null;
    var giftStateClean;

    if (!desiredGift || unavailable) {
      giftStateClean = marked.length === 0;
    } else {
      giftStateClean = marked.length === 1 && markedGiftCount === 1 && keep === marked[0];
    }

    return {
      qualifyingUnits: qualifyingUnits,
      percentageEligible: qualifyingUnits >= 4,
      tier: tier,
      desiredGift: desiredGift,
      markedLineKeys: marked.map(lineKey),
      markedLineCount: marked.length,
      markedGiftCount: markedGiftCount,
      updates: updates,
      giftToAdd: giftToAdd,
      giftStateClean: giftStateClean,
      unavailable: unavailable,
      declined: declined,
    };
  }

  function checkoutDecision(cart, config) {
    var state = inspectCart(cart, config);
    if (Object.keys(state.updates).length > 0 || state.giftToAdd) {
      return { action: 'reconcile', state: state };
    }
    if (state.unavailable || state.declined) return { action: 'allow_without_gift', state: state };
    return { action: 'allow', state: state };
  }

  function codedError(code, cause) {
    var error = new Error(code);
    error.code = code;
    if (cause !== undefined) error.cause = cause;
    return error;
  }

  function validateConfig(config) {
    if (!config || !Array.isArray(config.qualifyingProductIds) || config.qualifyingProductIds.length === 0) {
      throw new Error('qualifying_product_ids_invalid');
    }
    if (config.qualifyingProductIds.some(function (id) { return !/^[1-9][0-9]*$/.test(asId(id)); })) {
      throw new Error('qualifying_product_id_invalid');
    }
    if (config.pouchVariantId !== POUCH_VARIANT_ID) {
      throw new Error('pouch_variant_id_invalid');
    }
    if (['53954233598316','53954233631084'].indexOf(config.toteVariantId) === -1 || typeof config.toteAvailable !== 'boolean') throw new Error('tote_config_invalid');
    if (typeof config.pouchAvailable !== 'boolean') {
      throw new Error('gift_availability_invalid');
    }

    return assign({}, config, {
      qualifyingProductIds: config.qualifyingProductIds.map(asId),
    });
  }

  function sameDesiredGift(left, right) {
    if (!left || !right) return left === right;
    return left.variantId === right.variantId && left.available === right.available;
  }

  function isExactFinalState(initialState, finalDecision) {
    var finalState = finalDecision && finalDecision.state;
    if (!finalState || !finalState.giftStateClean) return false;
    if (Object.keys(finalState.updates).length > 0 || finalState.giftToAdd) return false;
    if (finalDecision.action !== 'allow' && finalDecision.action !== 'allow_without_gift') return false;
    return finalState.qualifyingUnits === initialState.qualifyingUnits
      && finalState.tier === initialState.tier
      && sameDesiredGift(finalState.desiredGift, initialState.desiredGift);
  }

  function createGiftReconciler(dependencies) {
    var inFlight = null;

    function runReconciliation(suppliedConfig) {
      var initialConfig;
      var initialState;
      var mutationResponse;
      var mutated = false;

      return Promise.resolve()
        .then(function () {
          return dependencies.readCart();
        })
        .catch(function (cause) {
          throw codedError('KD_HIRONO_CART_READ_FAILED', cause);
        })
        .then(function (cart) {
          var configResult;
          try {
            configResult = dependencies.readCampaignConfig
              ? dependencies.readCampaignConfig()
              : suppliedConfig;
          } catch (cause) {
            throw codedError('KD_HIRONO_CONFIG_READ_FAILED', cause);
          }

          return Promise.resolve(configResult)
            .then(function (config) {
              try {
                initialConfig = validateConfig(config);
              } catch (cause) {
                throw codedError('KD_HIRONO_CONFIG_READ_FAILED', cause);
              }
              var decision = checkoutDecision(
                enrichCart(cart, initialConfig.qualifyingProductIds),
                initialConfig
              );
              initialState = decision.state;
              return decision;
            }, function (cause) {
              throw codedError('KD_HIRONO_CONFIG_READ_FAILED', cause);
            });
        })
        .then(function (decision) {
          var updatePromise = Promise.resolve();
          if (Object.keys(decision.state.updates).length > 0) {
            mutated = true;
            updatePromise = Promise.resolve()
              .then(function () { return dependencies.updateCart(decision.state.updates); })
              .then(function (response) { mutationResponse = response; })
              .catch(function (cause) {
                throw codedError('KD_HIRONO_CART_UPDATE_FAILED', cause);
              });
          }

          return updatePromise.then(function () {
            if (!decision.state.giftToAdd) return decision;
            mutated = true;
            return Promise.resolve()
              .then(function () { return dependencies.addGift(decision.state.giftToAdd); })
              .then(function (response) {
                mutationResponse = response;
                return decision;
              })
              .catch(function (cause) {
                throw codedError('KD_HIRONO_GIFT_ADD_FAILED', cause);
              });
          });
        })
        .then(function (initialDecision) {
          if (!mutated) return initialDecision;

          return Promise.resolve()
            .then(function () { return dependencies.readCart(); })
            .then(function (cart) {
              var configResult;
              try {
                configResult = dependencies.readCampaignConfig
                  ? dependencies.readCampaignConfig()
                  : suppliedConfig;
              } catch (cause) {
                throw cause;
              }
              return Promise.resolve(configResult).then(function (config) {
                var verifiedConfig = validateConfig(config);
                var finalDecision = checkoutDecision(
                  enrichCart(cart, verifiedConfig.qualifyingProductIds),
                  verifiedConfig
                );
                if (!isExactFinalState(initialState, finalDecision)) {
                  throw new Error('post_verify_state_mismatch');
                }
                return assign({}, finalDecision, {
                  mutated: true,
                  response: mutationResponse,
                });
              });
            })
            .catch(function (cause) {
              throw codedError('KD_HIRONO_POST_VERIFY_FAILED', cause);
            });
        });
    }

    function reconcileGift(suppliedConfig) {
      if (inFlight) return inFlight;
      inFlight = runReconciliation(suppliedConfig).then(function (result) {
        inFlight = null;
        return result;
      }, function (error) {
        inFlight = null;
        throw error;
      });
      return inFlight;
    }
    reconcileGift.whenIdle = function () { return inFlight || Promise.resolve(); };
    return reconcileGift;
  }

  function createGiftPreferenceWriter(dependencies) {
    return function writeGiftPreference(declined) {
      var response;
      var preference = declined ? '1' : '0';
      return Promise.resolve().then(function () { return dependencies.waitForIdle(); })
        .then(function () { return dependencies.readCart(); })
        .then(function (cart) {
          var updates = {};
          if (declined) (cart.items || []).filter(isMarkedGift).forEach(function (item) {
            updates[lineKey(item)] = 0;
          });
          return dependencies.updatePreference(updates, { _kd_hirono_gift_declined: preference });
        })
        .then(function (result) { response = result; return dependencies.readCart(); })
        .then(function (cart) {
          if (!cart.attributes || cart.attributes._kd_hirono_gift_declined !== preference
            || (declined && (cart.items || []).some(isMarkedGift))) {
            throw new Error('gift_preference_verification_failed');
          }
          return response;
        });
    };
  }

  global.KDHironoGiftLogic = {
    activeElement: activeElement,
    asId: asId,
    checkoutDecision: checkoutDecision,
    checkoutControlFromEvent: checkoutControlFromEvent,
    createGiftReconciler: createGiftReconciler,
    createGiftPreferenceWriter: createGiftPreferenceWriter,
    enrichCart: enrichCart,
    inspectCart: inspectCart,
    isMarkedGift: isMarkedGift,
    parseIds: parseIds,
    replayCheckoutControl: replayCheckoutControl,
    setAcceleratedCheckoutBlocked: setAcceleratedCheckoutBlocked,
  };

  if (typeof document === 'undefined' || typeof customElements === 'undefined') return;
  if (global.__kdHironoGiftInit) return;
  global.__kdHironoGiftInit = true;

  var checkoutBypass = false;
  var giftPreferencePending = null;
  var giftPreferenceRevision = 0;
  var giftPreferenceFailed = false;

  function route(path) {
    var root = global.Shopify && global.Shopify.routes && global.Shopify.routes.root || '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function configFrom(element) {
    var pouchAvailable = element && element.dataset.pouchAvailable;
    if (pouchAvailable !== 'true' && pouchAvailable !== 'false') {
      throw new Error('gift_availability_invalid');
    }
    return {
      qualifyingProductIds: parseIds(element && element.dataset.qualifyingProductIds),
      pouchVariantId: asId(element && element.dataset.pouchVariantId),
      pouchAvailable: pouchAvailable === 'true',
      toteVariantId: asId(element && element.dataset.toteVariantId),
      toteAvailable: element && element.dataset.toteAvailable === 'true',
    };
  }

  function setStatus(element, message) {
    var status = element && element.querySelector('[data-kd-hirono-status]');
    if (status) status.textContent = message || '';
  }

  function setUpdatedStatus(element, decision) {
    var giftUpdated = decision && decision.mutated && decision.state.qualifyingUnits > 0;
    setStatus(element, giftUpdated ? element.dataset.updatedMessage : '');
  }

  function setReconciling(element, reconciling) {
    if (!element) return;
    if (reconciling) {
      element.dataset.reconciling = 'true';
      element.setAttribute('aria-busy', 'true');
      element.removeAttribute('data-reconcile-error');
      setAcceleratedCheckoutBlocked(element, true);
      return;
    }
    element.removeAttribute('data-reconciling');
    element.removeAttribute('aria-busy');
    setAcceleratedCheckoutBlocked(element, element.dataset.reconcileError === 'true');
  }

  function setReconcileError(element) {
    if (!element) return;
    element.dataset.reconcileError = 'true';
    setAcceleratedCheckoutBlocked(element, true);
  }

  function sectionsPayload() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return {};
    return {
      sections: drawer.getSectionsToRender().map(function (section) { return section.id; }),
      sections_url: global.location.pathname,
    };
  }

  function renderCart(response) {
    if (/\/cart\/?$/.test(global.location.pathname)) {
      global.location.reload();
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && response && response.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(response);
      return;
    }
    global.location.reload();
  }

  function fetchCart() {
    return fetch(route('cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_read_failed');
      return response.json();
    });
  }

  function fetchCampaignConfig() {
    return fetch(route('?sections=cart-drawer%2Cmain-cart'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    }).then(function (response) {
      if (!response.ok) throw new Error('campaign_config_read_failed');
      return response.json();
    }).then(function (sections) {
      var parser = new DOMParser();
      var renderedSections = [];
      if (sections && typeof sections === 'object') {
        Object.keys(sections).forEach(function (key) {
          renderedSections.push(sections[key]);
        });
      }
      for (var index = 0; index < renderedSections.length; index += 1) {
        if (typeof renderedSections[index] !== 'string') continue;
        var renderedDocument = parser.parseFromString(renderedSections[index], 'text/html');
        var renderedCampaign = renderedDocument.querySelector('kd-hirono-gift[data-campaign-active="true"]');
        if (renderedCampaign) return configFrom(renderedCampaign);
      }
      throw new Error('campaign_config_missing');
    });
  }

  function updateCart(updates, attributes) {
    return fetch(route('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(assign({ updates: updates }, attributes ? { attributes: attributes } : {}, sectionsPayload())),
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_update_failed');
      return response.json();
    });
  }

  function addGift(variantId) {
    var body = assign({
      items: [{
        id: Number(variantId),
        quantity: 1,
        properties: { _kd_hirono_gift: '1' },
      }],
    }, sectionsPayload());
    return fetch(route('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok || payload.status) throw new Error('cart_add_failed');
        return payload;
      });
    });
  }

  var giftReconciler = createGiftReconciler({
    readCart: fetchCart,
    readCampaignConfig: fetchCampaignConfig,
    updateCart: updateCart,
    addGift: addGift,
  });

  var giftPreferenceWriter = createGiftPreferenceWriter({
    waitForIdle: giftReconciler.whenIdle,
    readCart: fetchCart,
    updatePreference: updateCart,
  });

  function reconcileAfterPreference() {
    var revision = giftPreferenceRevision;
    return (giftPreferencePending || Promise.resolve()).then(function () {
      if (giftPreferenceFailed) throw new Error('gift_preference_not_saved');
      return giftReconciler();
    }).then(function (decision) {
      if (revision !== giftPreferenceRevision || giftPreferencePending) return reconcileAfterPreference();
      if (giftPreferenceFailed) throw new Error('gift_preference_not_saved');
      return decision;
    });
  }

  function reconcile(element) {
    if (!element || element.dataset.campaignActive !== 'true') return Promise.resolve(null);
    setReconciling(element, true);
    setStatus(element, element.dataset.updatingMessage || '');
    return reconcileAfterPreference().then(function (decision) {
      setReconciling(element, false);
      element.removeAttribute('data-reconcile-error');
      setUpdatedStatus(element, decision);
      if (decision && decision.mutated) renderCart(decision.response);
      return decision;
    }).catch(function () {
      setReconcileError(element);
      setReconciling(element, false);
      setStatus(element, element.dataset.errorMessage || '');
      return null;
    });
  }

  function KDHironoGift() {
    return Reflect.construct(HTMLElement, [], KDHironoGift);
  }
  KDHironoGift.prototype = Object.create(HTMLElement.prototype);
  KDHironoGift.prototype.constructor = KDHironoGift;
  KDHironoGift.prototype.connectedCallback = function () {
    reconcile(this);
  };

  customElements.define('kd-hirono-gift', KDHironoGift);

  document.addEventListener('click', function (event) {
    var preferenceControl = closestElement(event.target, '[data-kd-hirono-decline]');
    if (preferenceControl) {
      event.preventDefault();
      event.stopPropagation();
      if (giftPreferencePending) return;
      var preferenceElement = activeElement(preferenceControl, null, event);
      if (!preferenceElement) return;
      preferenceControl.disabled = true;
      giftPreferenceRevision += 1;
      giftPreferenceFailed = false;
      setReconciling(preferenceElement, true);
      setStatus(preferenceElement, preferenceElement.dataset.updatingMessage || '');
      giftPreferencePending = giftPreferenceWriter(preferenceControl.dataset.kdHironoDecline === '1');
      giftPreferencePending.then(function (response) {
        giftPreferencePending = null;
        renderCart(response);
      }, function () {
        giftPreferencePending = null;
        giftPreferenceFailed = true;
        setReconcileError(preferenceElement);
        setReconciling(preferenceElement, false);
        preferenceControl.disabled = false;
        setStatus(preferenceElement, preferenceElement.dataset.errorMessage || '');
      });
      return;
    }
    var checkout = checkoutControlFromEvent(event);
    if (!checkout) return;
    if (checkoutBypass) {
      checkoutBypass = false;
      return;
    }
    var campaignElement = activeElement(checkout, null, event);
    if (!campaignElement) return;
    event.preventDefault();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    else event.stopPropagation();
    checkout.disabled = true;
    setReconciling(campaignElement, true);
    setStatus(campaignElement, campaignElement.dataset.updatingMessage || '');
    reconcileAfterPreference().then(function (decision) {
      if (decision.action !== 'allow' && decision.action !== 'allow_without_gift') return;
      setReconciling(campaignElement, false);
      campaignElement.removeAttribute('data-reconcile-error');
      setUpdatedStatus(campaignElement, decision);
      checkoutBypass = true;
      checkout.disabled = false;
      try {
        if (!replayCheckoutControl(checkout)) throw new Error('checkout_replay_failed');
      } finally {
        checkoutBypass = false;
      }
    }, function () {
      setReconcileError(campaignElement);
      setReconciling(campaignElement, false);
      setStatus(campaignElement, campaignElement.dataset.errorMessage || '');
    }).then(function () {
      checkout.disabled = false;
    }, function () {
      setReconcileError(campaignElement);
      setReconciling(campaignElement, false);
      setStatus(campaignElement, campaignElement.dataset.errorMessage || '');
      checkout.disabled = false;
    });
  }, true);
})(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : this);
